import { render, staticRenderFns } from "./DownloadBtn.vue?vue&type=template&id=2cee8453&scoped=true"
import script from "./DownloadBtn.vue?vue&type=script&lang=js"
export * from "./DownloadBtn.vue?vue&type=script&lang=js"
import style0 from "./DownloadBtn.vue?vue&type=style&index=0&id=2cee8453&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cee8453",
  null
  
)

export default component.exports